module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C587"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("CONTENTS ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C600"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_ACKNOWLE#page_x"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "C600a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_INTRODUC#page_1"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "C603"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_INTRODUC#page_1"
    }
  }, [_vm._v("The Ethics of the Lie")])]), _vm._v(" "), _c('p', {
    staticClass: "C600a"
  }, [_c('a', {
    attrs: {
      "href": "#/html/08_CHAPTER#page_19"
    }
  }, [_vm._v("CHAPTER 1")])]), _vm._v(" "), _c('p', {
    staticClass: "C603"
  }, [_c('a', {
    attrs: {
      "href": "#/html/08_CHAPTER#page_19"
    }
  }, [_vm._v("The Snare of Truth: "), _c('em', [_vm._v("Following ")]), _vm._v("and the Perfect Patsy")])]), _vm._v(" "), _c('p', {
    staticClass: "C600a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_CHAPTER#page_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 2")])]), _vm._v(" "), _c('p', {
    staticClass: "C603"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/09_CHAPTER#page_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Memento")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/html/09_CHAPTER#page_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("and the Desire Not to Know")])]), _vm._v(" "), _c('p', {
    staticClass: "C600a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_CHAPTER#page_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 3")])]), _vm._v(" "), _c('p', {
    staticClass: "C603"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_CHAPTER#page_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dirty Cop: "), _c('em', [_vm._v("Insomnia ")]), _vm._v("and the Art of Detection")])]), _vm._v(" "), _c('p', {
    staticClass: "C600a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_CHAPTER#page_87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4")])]), _vm._v(" "), _c('p', {
    staticClass: "C603"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_CHAPTER#page_87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Banal Superhero: The Politicized Realism of "), _c('em', [_vm._v("Batman Begins ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C600a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_CHAPTER#page_103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5")])]), _vm._v(" "), _c('p', {
    staticClass: "C603"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_CHAPTER#page_103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Violence of Creation in "), _c('em', [_vm._v("The Prestige ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C600a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_CHAPTER#page_123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6")])]), _vm._v(" "), _c('p', {
    staticClass: "C603"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_CHAPTER#page_123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hero’s Form of Appearance: The Necessary Darkness of "), _c('em', [_vm._v("The Dark Knight ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C600a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_CHAPTER#page_147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7")])]), _vm._v(" "), _c('p', {
    staticClass: "C603"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_CHAPTER#page_147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Plea for the Abandonment of Reality in "), _c('em', [_vm._v("Inception ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C600a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_CONCLUSI#page_171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CONCLUSION")])]), _vm._v(" "), _c('p', {
    staticClass: "C603"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_CONCLUSI#page_171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lying without Consequence")])]), _vm._v(" "), _c('p', {
    staticClass: "C600a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_NOTES#page_179",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "C600a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_BIBLIOGR#page_209",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BIBLIOGRAPHY")])]), _vm._v(" "), _c('p', {
    staticClass: "C600a"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_INDEX#page_216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39863056","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/05_Contents.vue
// module id = 72
// module chunks = 0